import React from "react";
import AuthWindow from "@components/Auth/AuthWindow";
import RegisterForm from "@components/Auth/RegisterForm";

function Register() {
  const [loginError, setLoginError] = React.useState<string | undefined>();
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <AuthWindow
      action="Registrieren"
      alternativeActionPreamble="Bereits einen Account?"
      alternativeActionLink="/account/auth/login"
      alternativeActionText="Anmelden"
      isLoading={isLoading}
      error={loginError}
    >
      <RegisterForm setIsLoading={setIsLoading} setLoginError={setLoginError} />
    </AuthWindow>
  );
}

export { getStaticProps } from "@lib/utils/translationsStaticProps";
export default Register;
